import {
	OrderGridTableMemoized,
	OrderParticipants,
	OrderPerson,
	OrderResources,
	OrderTime,
	useOrderInfo,
} from 'entities/orders';
import {
	selectOrdersError,
	selectOrdersGroups,
} from 'entities/orders/model/selectors';
import { useMemo, useState } from 'react';
import { useAppSelector } from 'shared/lib/store';
import { OrderTimeHeader } from './headers/orderTimeHeader/orderTimeHeader';
import { OrderDateHeader } from './headers/orderDateHeader/orderDateHeader';
import { OrderNotesMarker } from 'entities/orders';
import { Tags } from 'entities/tags';
import { Flex } from 'shared/ui/flex';
import { OrderEdit } from 'entities/orders/ui/ordersTableColumns/orderEdit/orderEdit';
import { OrderConfirm } from 'entities/orders/ui/ordersTableColumns/orderConfirm/orderConfirm';
import { OrderAmount } from 'entities/orders/ui/ordersTableColumns/orderAmount/orderAmount';
import { OrderCreated } from 'entities/orders/ui/ordersTableColumns/orderCreated/orderCreated';
import { PaginationHook, usePaginationFilter } from 'shared/lib/pagination';



export const OrdersTableList = () => {

	const ordersGroups = useAppSelector(selectOrdersGroups);
	const error = useAppSelector(selectOrdersError);
	const { open, setSelectedId } = useOrderInfo();

  const { fetchDataWithDispatch } =
		usePaginationFilter() as PaginationHook;

	const [currentRowId, setCurrentRowId] = useState<number | undefined>(
		undefined,
	);


	// const [rows, setRows] = useState<GridRows[]>([]);

	const selectOrder = async (id: number) => {
    await fetchDataWithDispatch();
		open();
		setCurrentRowId(id);
		setSelectedId(id);
	};

  const changeOrderConfirmCallback = async (id: number) => {
    await fetchDataWithDispatch();
    selectOrder(id)
  }

	// useEffect(() => {
	// 	if (ordersGroups.length) {
	// 		const rowsArray = ordersGroups.map(orderGroup => {
	// 			return {
	// 				header: (
	// 					<OrderDateHeader date={orderGroup.date} withShadow />
	// 				),
	// 				rows: orderGroup.orders.map(order => {
	// 					return {
	// 						header: <OrderTimeHeader time={order.time} />,
	// 						cells: order?.ordersList?.map(order => {
	// 							return {
	// 								id: order.id,
	// 								fields: [
	// 									<OrderPerson
	// 										person={order.person}
	// 										width="14vw"
	// 										textBold
	// 									/>,
	// 									<Flex $direction="column" $gap="6px">
	// 										<Flex $gap="8px" $alignItems="center">
	// 											<OrderTime order={order} />
	// 											<OrderParticipants order={order} />
	// 										</Flex>
	// 										<OrderResources order={order} row />
	// 									</Flex>,
	// 									<Tags
	// 										tags={order.tags}
	// 										tagsFor={'order'}
	// 										currentEntityId={order.id}
	// 										doubleRows
	// 									/>,
	// 									<OrderAmount order={order} />,
	// 									<OrderCreated order={order} />,
	// 									<Flex $alignItems="center" $gap="8px" style={{ height: '100%' }}>
	// 										<OrderConfirm order={order} mode="small" callback={selectOrder} />
	// 										<OrderEdit order={order} />
	// 										<OrderNotesMarker order={order} />
	// 									</Flex>
	// 								],
	// 							};
	// 						}),
	// 					};
	// 				}),
	// 			};
	// 		});

	// 		setRows(rowsArray);
	// 	} else {
	// 		setRows([]);
	// 	}
	// 	//eslint-disable-next-line
	// }, [ordersGroups]);

  const rows = useMemo(() => {
    if (!ordersGroups.length) return [];

    const rowsArray = ordersGroups.map(orderGroup => {
      return {
        header: (
          <OrderDateHeader date={orderGroup.date} withShadow />
        ),
        rows: orderGroup.orders.map(order => {
          return {
            header: <OrderTimeHeader time={order.time} />,
            cells: order?.ordersList?.map(order => {
              return {
                id: order.id,
                fields: [
                  <OrderPerson
                    person={order.person}
                    width="14vw"
                    textBold
                  />,
                  <Flex $direction="column" $gap="6px">
                    <Flex $gap="8px" $alignItems="center">
                      <OrderTime order={order} />
                      <OrderParticipants order={order} />
                    </Flex>
                    <OrderResources order={order} row />
                  </Flex>,
                  <Tags
                    tags={order.tags}
                    tagsFor={'order'}
                    currentEntityId={order.id}
                    doubleRows
                  />,
                  <OrderAmount order={order} />,
                  <OrderCreated order={order} />,
                  <Flex $alignItems="center" $gap="8px" style={{ height: '100%' }}>
                    <OrderConfirm order={order} mode="small" callback={changeOrderConfirmCallback} />
                    <OrderEdit order={order} selectOrder={selectOrder} />
                    <OrderNotesMarker order={order} />
                  </Flex>,
                ],
              };
            }),
          };
        }),
      };
    });

    return rowsArray;
    //eslint-disable-next-line
  }, [ordersGroups])

	return (
		<OrderGridTableMemoized
			tableRows={rows}
			columnCount={6}
			setCurrentRowId={setCurrentRowId}
			selectOrder={selectOrder}
			currentRowId={currentRowId}
			gridSettings={{
				moreSpaceForLastColumn: false,
				columnSize: 8,
			}}
			specificColumnSizes={[
				{ index: 1, size: 3 },
				{ index: 2, size: 2 },
				{ index: 3, size: 10 },
				{ index: 4, size: 3 },
				{ index: 5, size: 2 },
				{ index: 6, size: 2 },
			]}
			gridStyles={{
				rowPadding: '8px 10px',
				rowsHeight: 'calc(100dvh - 140px)',
				rowMargin: '0px',
				rowCorners: '0px',
			}}
			error={error}
		/>
	);
};
